






































import { Component, Vue, Inject, Prop} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ProjectAddForm from './projectAddForm.vue'
@Component({
    name:'projectAdd',
    components: {
        ProjectAddForm
    }
})
export default class projectAdd extends AbpBase {   
    @Prop({type:Array}) editData:any;
    initData:any = {
        modalData: {
            status: false,
            btnLoading: true,
            content: {},
            projectData: {},
            hasReverse: false
        }
    }
    ToDetail(){   
        this.initData.modalData.status = false;         
        this.$router.push({
            name: 'projectDetail',
            query: {
                id: this.initData.modalData.projectData.id
            }
        })
    }
    //项目提交
    Submit() {
        (this as any).$refs.ProjectAddForm.Submit();
    }
    //倒排工期提交
    ShowModal(status:boolean, data:any) {
        this.initData.modalData.projectData = data;
        //判断是否存在倒排工期数据
        if(data.reverse){
            this.initData.modalData.hasReverse = true;
            this.initData.modalData.content.fieldConstructionFinishDt = data.reverse.fieldConstructionFinishDt;
            this.initData.modalData.content.fieldAcceptanceDt = data.reverse.fieldAcceptanceDt;
            this.initData.modalData.content.reportReviewFilingDt = data.reverse.reportReviewFilingDt;
            this.initData.modalData.content.dataExchangeDt = data.reverse.dataExchangeDt;
            this.initData.modalData.content.submitFinalAccountDt = data.reverse.submitFinalAccountDt;
        }
        this.initData.modalData.status = status;
    }
    TimeSubmit() {            
        (this.$refs.timeform as any).validate(async (valid:boolean)=>{
            if(valid){
                this.initData.modalData.content.projectId = this.initData.modalData.projectData.id;
                if(this.initData.modalData.hasReverse){
                    this.initData.modalData.content.contractId = this.initData.modalData.projectData.reverse.contract.id;
                    this.initData.modalData.content.id = this.initData.modalData.projectData.reverse.id;
                    Ajax.put('/api/services/app/Contract/UpdateReverseAsync', this.initData.modalData.content).then((res:any)=>{
                        this.$Message.success('修改成功!');
                        this.initData.modalData.status = false;
                        setTimeout(()=>{
                            this.$router.push({
                                name: 'projectDetail',
                                query: {
                                    id: this.initData.modalData.projectData.id
                                }
                            })
                        },1500)
                    });
                }else{
                    Ajax.post('/api/services/app/Contract/CreateReverseAsync', this.initData.modalData.content).then((res:any)=>{
                        this.$Message.success('提交成功!');
                        this.initData.modalData.status = false;
                        setTimeout(()=>{
                            this.$router.push({
                                name: 'projectDetail',
                                query: {
                                    id: this.initData.modalData.projectData.id
                                }
                            })
                        },1500)
                    });
                }
            }else{                    
                setTimeout(() => {
                    this.initData.modalData.btnLoading = false;
                    this.$nextTick(() => {
                        this.initData.modalData.btnLoading = true;
                    });
                }, 1000);
            }
        })
    }
    mounted() {
    }
    rules:any = {            
        fieldConstructionFinishDt: [{ required: true, message: '请选择野外施工结束日期'}],
        fieldAcceptanceDt: [{ required: true, message: '请选择野外验收日期'}],
        reportReviewFilingDt: [{ required: true, message: '请选择报告评审备案日期'}],
        dataExchangeDt: [{ required: true, message: '请选择资料汇交日期'}],
        submitFinalAccountDt: [{ required: true, message: '请选择提交决算申请日期'}],
    }
}
